import { z } from 'zod';
export const tokenExchangeRequestSchema = z.object({
    token: z.string().min(1),
});
export const messageAttachmentSchema = z.object({
    fileId: z.string().uuid(), // conversation_files row holding the uploaded bytes
    name: z.string().min(1).max(255),
    mimeType: z.string().max(255),
    size: z.number().int().nonnegative(),
    content: z.string().max(200_000), // extracted text, not the raw file
});
export const sendMessageRequestSchema = z
    .object({
    conversationId: z.string().uuid(),
    content: z.string().max(32_000).default(''),
    attachments: z.array(messageAttachmentSchema).max(10).optional(),
})
    .refine((v) => v.content.trim().length > 0 || (v.attachments?.length ?? 0) > 0, { message: 'Message must have text or at least one attachment' });
export const createConversationRequestSchema = z.object({
    title: z.string().max(255).optional(),
});
export const skillConfigSchema = z.object({
    identity: z.object({
        name: z.string().min(1).max(100),
        description: z.string().max(500),
        whenToUse: z.string().max(1000),
    }),
    triggers: z.array(z.object({
        type: z.enum(['keyword', 'intent', 'context', 'always']),
        value: z.string(),
    })),
    toolGrants: z.array(z.object({
        toolType: z.string(),
        toolIdentifier: z.string(),
    })),
    approvalRules: z.array(z.object({
        field: z.string(),
        operator: z.enum(['eq', 'gt', 'lt', 'gte', 'lte', 'contains']),
        value: z.union([z.string(), z.number()]),
    })),
    contextBlocks: z.array(z.object({
        label: z.string(),
        content: z.string(),
    })),
});
export const createSkillRequestSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500),
    config: skillConfigSchema,
});
export const updateSkillRequestSchema = createSkillRequestSchema.partial();
export const createCustomerRequestSchema = z.object({
    name: z.string().min(1).max(255),
    hostAccountId: z.string().min(1),
    planId: z.string().uuid(),
    credentialMode: z.enum(['platform_managed', 'byok']),
});
export const byokCredentialRequestSchema = z.object({
    provider: z.enum(['anthropic', 'openai']),
    apiKey: z.string().min(1),
});
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
const emptyToUndef = (v) => (v === '' ? undefined : v);
const optionalStr = z.preprocess(emptyToUndef, z.string().optional());
const optionalUrl = z.preprocess(emptyToUndef, z.string().url().optional());
export const updateNetsuiteConfigRequestSchema = z
    .object({
    downstreamType: z.enum(['mock', 'restlet', 'native_mcp']),
    restletUrl: optionalUrl,
    tokenEndpoint: optionalUrl,
    oauthClientId: optionalStr,
    oauthCertId: optionalStr,
    oauthScope: optionalStr,
    nativeMcpUrl: optionalUrl,
})
    .superRefine((v, ctx) => {
    if (v.downstreamType === 'restlet') {
        ['restletUrl', 'tokenEndpoint', 'oauthClientId', 'oauthCertId'].forEach((f) => {
            if (!v[f])
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: [f],
                    message: `${f} is required for restlet`,
                });
        });
    }
    if (v.downstreamType === 'native_mcp' && !v.nativeMcpUrl) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['nativeMcpUrl'],
            message: 'nativeMcpUrl is required for native_mcp',
        });
    }
});
//# sourceMappingURL=api.js.map